var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoresaver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 4096 4096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient)}.cls-2,.cls-3{fill:#fff;fill-rule:evenodd}.cls-3{stroke:#fff}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 4096,
    y1: 2048,
    y2: 2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#137bf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#1c78f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#366eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5f5fdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#984ac8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9c49c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa152d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4096,
    height: 4096,
    className: "cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---SR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bt-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-cloud-download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3170.51,1141.41c395.66,0,721.49,328.25,721.49,726.84,0,410.31-325.83,726.84-721.49,726.84H866.4c-360.75,0-663.31-246.19-663.31-621.34,0-363.42,302.56-656.5,663.31-656.5H971.13C982.77,989,1250.42,731.09,1576.25,731.09c151.28,0,290.92,58.62,395.66,152.4,104.73-222.74,314.19-363.42,570.21-363.42,337.47,0,616.75,281.36,628.39,621.34Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "1701.55 2191.14 2430.28 2191.14 2430.28 2857.31 2739.22 2857.31 2047.55 3574.48 1355.88 2857.31 1701.55 2857.31 1701.55 2191.14",
    className: "cls-3"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoresaver);
export default __webpack_public_path__ + "static/media/scoresaver.3f65e348c800bf5d953d154e01b14da2.svg";
export { ForwardRef as ReactComponent };